module.exports = __webpack_public_path__ + "img/4-6-tour-4.c1f944dd.jpg";